<template>
    <div class="card-body">
        <div class="form">
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="manager.activar_compra_por_invitacion_bases" id="activar_compra_por_invitacion_bases">
                    <label class="custom-control-label text-uppercase" for="activar_compra_por_invitacion_bases">Activar la inscripción  cantera por invitación con código</label>
                </div>
            </div>
            <div class="form-group">
                <div class="custom-control custom-switch">
                    <input class="custom-control-input" type="checkbox" v-model="manager.documentacion_obligatoria_bases" id="documentacion_obligatoria_bases">
                    <label class="custom-control-label text-uppercase" for="documentacion_obligatoria_bases">La documentación del deportista será obligatoria en el proceso de compra</label>
                </div>
            </div>
            <div class="form-group">
                <label class="form-label" for="informacion">Texto de información sobre las bases:</label>
                <CkEditorComponent v-model="manager.informacion_base"/>
            </div>
            <div class="form-group">
                <label class="form-label" for="informacion">Texto para las condiciones de la compra en cantera mediante plazos:</label>
                <CkEditorComponent v-model="manager.condiciones_bases_plazos"/>
            </div>
            <div class="form-group">
                <label for="imagen">Imagen cantera:</label>
                <p>
                    <small>
                        MEDIDAS: 1000X1200 - FORMATO: JPG 
                        <br>
                        * No introduzcas texto en la imagen. 
                    </small>                   
                </p>
                <div class="text-center" v-if="manager.imagen_info_bases_url">
                    <template>
                        <br>
                        <img :src="manager.imagen_info_bases_url" style="max-height: 200px">
                        <br>
                        <Button class="mt-3" @click="imagenBorrada()">Borrar</Button>
                    </template>
                </div>
                <template v-else>
                    <vue-dropzone
                        ref="myVueDropzone"
                        id="dropzone"
                        :options="dropzoneOptions"
                        v-on:vdropzone-success="imagenSubida(...arguments)"
                        v-on:vdropzone-removed-file="imagenBorrada()"
                    ></vue-dropzone>
                </template>
            </div>
            <div class="mt-2 text-right"> 
                <Button @click="guardarOpciones">Guardar</Button>
            </div>
        </div>
    </div>
</template>

<script>
import CkEditorComponent from '@/components/common/forms/CkEditorComponent.vue';
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
    props: ['manager'],
    data() {
        return {
            dropzoneOptions: {
                url: this.config.API_BASE + '/upload/image?permisos=public&api_key=' + localStorage.getItem('token'),
                thumbnailWidth: 150,
                maxFilesize: 0.5,
                acceptedFiles: "image/png, image/jpeg",
                resizeHeight: 1200,
                resizeWidth: 1000,
                headers: { "My-Awesome-Header": "header value" },
                uploadMultiple: false,
                maxFiles: 1,
                addRemoveLinks: true
            },
            conf: {}
        }
    },
    methods: {
        imagenBorrada() {
            this.manager.imagen_info_bases = null;
            this.manager.imagen_info_bases_url = null;
        },
        imagenSubida(file, response) {
            this.manager.imagen_info_bases = response;
        },
        guardarOpciones() {
            this.$emit('guardar');
        }
    },
    components: { CkEditorComponent, vueDropzone: vue2Dropzone }
}
</script>